<template>
  <VlButton :mod-narrow="true" @click="openLoginUrl" title="Genesys login">
    Login
  </VlButton>
</template>

<script>
export default {
  methods: {
    openLoginUrl() {
      window.open(process.env.VUE_APP_CTI_LOGIN_URL, '_self');
    },
  },
};
</script>
